export const staffMemberPageHeaderRow = (staffName, columnCount, textStyle) => {
	const row = [{
		text: `Staff member: ${staffName}`,
		style: textStyle,
		colSpan: columnCount,
		fillColor: "#eef2f7",
		margin: [0, 2, 0, 4]
	}];
	for (let i = 1; i < columnCount; i++) {
		row.push({});
	}
	return row;
};

export const withRepeatingStaffName = (headerRow, records, staffName, textStyle) => {
	const body = [headerRow, ...records];
	if (!staffName) {
		return { headerRows: 1, body };
	}
	body.unshift(staffMemberPageHeaderRow(staffName, headerRow.length, textStyle));
	return { headerRows: 2, body };
};
